// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPayorResult {
    static getAttributeTypeMap() {
        return PharmacyBiPayorResult.attributeTypeMap;
    }
}
PharmacyBiPayorResult.discriminator = undefined;
PharmacyBiPayorResult.additionalProperties = false;
PharmacyBiPayorResult.attributeTypeMap = [
    {
        "name": "agentName",
        "baseName": "agentName",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "referenceId",
        "baseName": "referenceId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPayorResult.js.map